<div
  #chart
  class="echarts-container"
  [attr.aria-label]="accessibleName() ?? null"
    [attr.role]="accessibleName() ? 'img' : null"
  [class.echarts-container--empty]="!hasData()"></div>
@if (!hasData()) {
  <shared-echarts-empty
    class="empty-state"
    [hasBorderIfNoData]="hasBorderIfNoData()" />
}